export const environment = {
  production: true,
  url: 'https://api.tourfacyl.es',
  webUrl: 'https://app.tourfacyl.es',
  translocoUrl: '/assets/i18n/',
  distanceRadios: [1, 5, 20],
  priceRangeLower: 0,
  priceRangeUpper: 18,
  googleMapsKey: 'AIzaSyBmWodOL53o04fz8B_UTm5WnC9YxNA9rJk',
  googleMapsKeyAndroid: 'AIzaSyBokQy7q_8Cp5NWUbY4kGGNu0Zwdv1K_R0',
  googleWebClientId:
    '181777987669-snh3k2he8h7rchudrlshod64afe8kl59.apps.googleusercontent.com',
  iosWebClientId:
    '181777987669-enf83maikctnj70qtm87rhoh1q7njqb3.apps.googleusercontent.com',
  androidWebClientId:
    '181777987669-snh3k2he8h7rchudrlshod64afe8kl59.apps.googleusercontent.com',
  facebookAppId: 2444137029295639,
  catalogDefaultPicture: 'https://cdn.tourfacyl.es/email/default_commerce_image.png',
  userDefaultPicture: 'https://cdn.tourfacyl.es/email/default_user_image.png',
  menuDefaultPicture: 'https://cdn.tourfacyl.es/email/default_menu_image.jpg',
  stripePublishableKey: 'pk_live_51R7BkSG0nNjpxww9SXGmwC6MVfPcyCEhpREZyfmHrwkvzLBQNacpuh1BcXDWL4169uzZY5obsnJnFf1nmZ0LPRuD00SX0xTCpE',
  reCaptchaSiteKey: '6LdnyY0rAAAAAFaIM8H9_dtHBpA-nce1Hyat3TGj',
  policy_codes: {
    terms_conditions: 'TourFacyl-usage-conditions',
    privacy_policies: 'TourFacyl-privacy-policies',
    legal_advice: 'TourFacyl-legal-advice',
    cookies_policy: 'TourFacyl-cookies-policy'
  },
  external_api_ulrl:'https://jcyl.opendatasoft.com/api/explore/v2.1/catalog/datasets/registro-de-turismo-de-castilla-y-leon',
  language_api:'https://api.tourfacyl.es/api/v1/language'
};
